import React from 'react';
import CheckboxToggle from '../../design-system/checkbox-toggle.jsx';

export const CheckboxSwitcher = ({ className, isSubscribed, onChange }) => (
  <CheckboxToggle
    className={className}
    selected={isSubscribed}
    onChange={() => onChange(!isSubscribed)}
  >
    Subscribe &amp;&nbsp;save
  </CheckboxToggle>
);
